import React from 'react'
import { useIntl } from 'react-intl'
import { Button } from '../../../../components/Button'
import { ArrivalRouteAction } from '../../../../components/SosSubForm/ArrivalRoute/types'
import { SubmitFormType } from './types'
import { routeSubformMessages } from './subforms/messages'

interface EditMenuProps {
  selectedForm: SubmitFormType
  action: ArrivalRouteAction
  setAction: (action: ArrivalRouteAction) => void
  canEditArrived: boolean
  canEditFinished: boolean
}

export const EditMenu = ({ selectedForm, action, setAction, canEditArrived, canEditFinished }: EditMenuProps) => {
  const intl = useIntl()
  const showEditArrived = canEditArrived && selectedForm === 'arrived'
  const showEditFinished = canEditFinished && selectedForm === 'finished'
  
  const onEditArrivalCancelMoveToFinished = canEditArrived && !canEditFinished && action === "edit-arrived"

  const handleEditArrived = () => {
    if(onEditArrivalCancelMoveToFinished) {
      setAction("edit-finished")
      return
    }
    if (action === 'edit-arrived') {
      setAction('default')
    } else {
      setAction('edit-arrived')
    }
  }

  const handleEditFinished = () => {
    if (action === 'edit-finished') {
      setAction('default')
    } else {
      setAction('edit-finished')
    }
  }
  
  return (
    <>
      {showEditArrived && (
        <>
          <Button
            onClick={handleEditArrived}
            category="yellow"
            size="l"
            label={intl.formatMessage(action === 'edit-arrived' ? routeSubformMessages.cancelModal : routeSubformMessages.edit)}
            maxWidth="100%"
          />
          <Button
            category="save"
            size="l"
            label={intl.formatMessage(routeSubformMessages.saveArrived)}
            mobileLabel={intl.formatMessage(routeSubformMessages.saveDepartureMobile)}
            submit
            maxWidth="100%"
          ></Button>
        </>
      )}
      {showEditFinished && (
        <>
          <Button
            onClick={handleEditFinished}
            category="yellow"
            size="l"
            label={intl.formatMessage(action === 'edit-finished' ? routeSubformMessages.cancelModal : routeSubformMessages.edit)}
            maxWidth="100%"
          />
          <Button
            category="save"
            size="l"
            label={intl.formatMessage(routeSubformMessages.saveFinished)}
            mobileLabel={intl.formatMessage(routeSubformMessages.saveDepartureMobile)}
            submit
            maxWidth="100%"
          ></Button>
        </>
      )}
    </>
  )
}
